import React from 'react';
import { Input, Button, DatePicker, Tooltip, Select } from 'components';
import { MissionService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

class CreateMission extends React.Component<Props> {

	state = {
		form: {
			type: Constants.MISSION_TYPES.DAYS_BEFORE,
			days_before: '',
			since: '',
			until: '',
			date: '',
			points: '',
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					type: this.props.item?.type || Constants.MISSION_TYPES.DAYS_BEFORE,
					since: this.props.item?.since ? moment(this.props.item?.since).toDate() : '',
					until: this.props.item?.until ? moment(this.props.item?.until).toDate() : '',
					date: this.props.item?.date ? moment(this.props.item?.date).toDate() : '',
					points: this.props.item?.points || '',
					days_before: this.props.item?.days_before || ''
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();	

		const { type, since, until, date, days_before } = this.state.form;

		if (type == Constants.MISSION_TYPES.DAYS_BEFORE) {
			if (!days_before || !since || !until) {
				Globals.showError("Por favor, ingrese todos los datos para continuar");
				return;
			}

			if (since > until) {
				Globals.showError("Las fechas no son válidas");
				return;
			}
		}

		if (type == Constants.MISSION_TYPES.DAY) {
			if (!date) {
				Globals.showError("Por favor, ingrese la fecha para continuar");
				return;
			}
		}

		if (this.props.item != null) {
			await MissionService.admin.update({
				mission_id: this.props.item?.id,
				...this.state.form,
				since: this.state.form?.since ? moment(this.state.form?.since).format('YYYY-MM-DD') : '',
				until: this.state.form?.until ? moment(this.state.form?.until).format('YYYY-MM-DD') : '',
				date: this.state.form?.date ? moment(this.state.form?.date).format('YYYY-MM-DD') : '',
			});
			Globals.showSuccess("Se ha modificado la misión correctamente");
			this.props.onClose();
		}
		else {
			await MissionService.admin.create({
				...this.state.form,
				since: this.state.form?.since ? moment(this.state.form?.since).format('YYYY-MM-DD') : '',
				until: this.state.form?.until ? moment(this.state.form?.until).format('YYYY-MM-DD') : '',
				date: this.state.form?.date ? moment(this.state.form?.date).format('YYYY-MM-DD') : '',
			});
			Globals.showSuccess("Se ha creado la misión correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		const { type } = this.state.form;

		return (
			<div id="modal-create-mission">
				<form onSubmit={ this.submit }>
					<div className="container-inputs row">
						<div className="col-md-12">
							<Select
								placeholder="Seleccionar"
								label="Tipo de Misión"
								name="type"
								color="white"
								onChange={ this.change }
								value={ this.state.form.type }
								options={ [
									{ value: Constants.MISSION_TYPES.DAYS_BEFORE.toString(), label: 'Pagar días antes' },
									{ value: Constants.MISSION_TYPES.DAY.toString(), label: 'Pagar un día especifico' },
								] } />
						</div>
						{
							type == Constants.MISSION_TYPES.DAYS_BEFORE && (
								<>
									<div className="col-md-5">
										<Input
											type="number"
											color="white"
											value={ this.state.form.days_before }
											name="days_before" 
											label="Días antes"
											onChange={ this.change } />
									</div>
									<div className="col-md">
										<DatePicker
											showYearDropdown={ true }
											label="Válido desde"
											minDate={ moment().toDate() }
											onChange={ (text: string) => {
												this.change({
													target: {
														value: text,
														name: 'since'
													}
												});
											} }
											value={ this.state.form.since }
										/>
									</div>
									<div className="col-md">
										<DatePicker
											showYearDropdown={ true }
											label="Válido hasta"
											minDate={ moment().toDate() }
											onChange={ (text: string) => {
												this.change({
													target: {
														value: text,
														name: 'until'
													}
												});
											} }
											value={ this.state.form.until }
										/>
									</div>
								</>
							)
						}
						{
							type == Constants.MISSION_TYPES.DAY && (
								<>
									<div className="col-md-6">
										<DatePicker
											showYearDropdown={ true }
											label="Fecha"
											minDate={ moment().toDate() }
											onChange={ (text: string) => {
												this.change({
													target: {
														value: text,
														name: 'date'
													}
												});
											} }
											value={ this.state.form.date }
										/>
									</div>
								</>
							)
						}
						<div className="col-md-6">
							<Input
								type="number"
								color="white"
								value={ this.state.form.points }
								name="points" 
								label="Puntos a acreditar"
								onChange={ this.change } />
						</div>
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateMission;